import axios from 'axios'
import store from '@/store'
//import Cookies from 'js-cookie'
async function getAllCnpjs() {
    try {
        const result = await axios.get(`${process.env.VUE_APP_ROOT_API}/clients/v1/cnpj`, {
            headers: {
                Authorization: `Bearer ${store.state.user.token}`
            }
        });
        const companysInfo = []

        const groupsIds = result.data.payload.group.map((buyers) => { return buyers.economicGroups[0].id })
        const groups = [...new Set(groupsIds)].map((groupId) => {
            const buyers = result.data.payload.group.filter((buyer) => { return buyer.economicGroups[0].id == groupId })
            return {...buyers[0], name: buyers[0].economicGroups[0].name }
        })

        const sponsorGroupIds = result.data.payload.sponsorGroup.map((buyers) => { return buyers.economicGroups[0].id })

        const sponsorGroup = [...new Set(sponsorGroupIds)].map((groupId) => {
            const sponsors = result.data.payload.sponsorGroup.filter((sponsor) => { return sponsor.economicGroups[0].id == groupId })
            return {...sponsors[0], name: sponsors[0].economicGroups[0].name }
        })

        const companys = [
            ...result.data.payload.cashforce,
            ...result.data.payload.provider,
            ...result.data.payload.buyer,
            ...result.data.payload.sponsor,
            ...groups
        ]

        companys.map((company) => {
            const partners = [...new Set(
                company.economicGroups
                ? company.economicGroups.map(e => e.partnerId)
                : company.partners
                    ? company.partners.map(partner => partner.id)
                    : []
            )]
            companysInfo.push({
                id: company.id,
                name: company.name,
                tradingName: company.tradingName,
                cnpj: {
                    id: company.cnpj.id,
                    cnpj: company.cnpj.cnpj,
                    companyType: company.cnpj.companyType,
                    profile: company.cnpj.companyType
                },
                partners
            })
        })
        console.log(companysInfo);
        
        sponsorGroup.map((company) => {
            console.log(company.economicGroups);
            
            const partners = [...new Set(company.economicGroups ? company.economicGroups.map(e => e.partnerId) : [])]
            companysInfo.push({
                id: company.id,
                name: company.name,
                tradingName: company.tradingName,
                cnpj: {
                    id: company.cnpj.id,
                    cnpj: company.cnpj.cnpj,
                    companyType: 0,
                    profile: 0
                },
                partners
            })
        })

        store.commit('user/setCompanys', companysInfo)
        //Cookies.set('companyInfo', JSON.stringify(companysInfo), { expires: 1, domain: process.env.VUE_APP_ROOT_DOMAIN })
        return result.data.payload
    } catch (err) {
        console.log(err)
        if (err.data && err.data.message.name == 'TokenExpiredError') {
            return window.location.href = `${this.getServiceUrls.CLIENT}/`
        }
    }
}

export default getAllCnpjs